// <s-split-reveal> maps the scroll progress through its tall wrapper to a --split custom
// property (0 → 1) on itself. CSS uses it to slide the two cover panels apart and bring
// the revealed layer forward. Fully reversible: progress follows the scroll position.
class SSplitReveal extends HTMLElement {
  #ac;
  #raf = 0;
  #reduced;

  connectedCallback() {
    this.#ac = new AbortController();
    this.#reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (this.#reduced.matches || this.hasAttribute('data-static')) {
      this.style.setProperty('--split', '1');
      return;
    }
    this.setAttribute('data-ready', '');
    const opts = { signal: this.#ac.signal, passive: true };
    window.addEventListener('scroll', this.#schedule, opts);
    window.addEventListener('resize', this.#schedule, opts);
    this.#schedule();
  }

  disconnectedCallback() {
    this.#ac?.abort();
    cancelAnimationFrame(this.#raf);
  }

  #schedule = () => {
    cancelAnimationFrame(this.#raf);
    this.#raf = requestAnimationFrame(this.#update);
  };

  #update = () => {
    const rect = this.getBoundingClientRect();
    const travel = rect.height - window.innerHeight;
    if (travel <= 0) {
      this.style.setProperty('--split', '1');
      return;
    }
    const raw = Math.min(Math.max(-rect.top / travel, 0), 1);
    // Hold the closed composition briefly, split through the middle, then hold the reveal.
    const p = Math.min(Math.max((raw - 0.12) / 0.66, 0), 1);
    this.style.setProperty('--split', p.toFixed(4));
  };
}

if (!customElements.get('s-split-reveal')) customElements.define('s-split-reveal', SSplitReveal);
